export default "__VITE_ASSET__9xdO4Y3U__"